import * as IF from "infrontjs";
import { InAppState } from "../base/InAppState";

import template from './LogoutTemplate.html';

export class LogoutState extends InAppState
{
    static ROUTE = '/logout';
    static ID = 'logout';

    async enter()
    {
        const result = await this.app.destroySession();
        const mainWrapper = this.app.container.querySelector('#main-wrapper' );
        this.app.view.render(
            mainWrapper,
            template
        );
    }
}
